import {useEffect, useState} from "react";
import notesApi from "../modules/notes/api/NotesApi";
import Note from "../modules/notes/model/Note";
import { Link } from "react-router-dom";
import moment from "moment";
import { Alert } from "react-bootstrap";
import NotesByRow from "../modules/notes/components/NotesByRow";

export default function DashboardPage() {

    const [favoritesNotes, setFavorites] = useState<Note[]>([])
    useEffect(()=>{
        loadFavoritesNotes();
    }, [])

    const loadFavoritesNotes = () => {
        let filter = {
            favorites: true
        }
        notesApi.getNotes(filter, 0)
            .then(data => {
                setFavorites(data.content)
            })
    } 

    const toggleFavorites = (noteId: number, favorites: boolean) => {
        return false;
        // NotesApi.setNoteFavorites(noteId, favorites)
        //     .then(() => {
        //         setNote({...note, favorites});
        //     })
    }

    return (
        <>
            <h1>Избранные заметки</h1>
            {favoritesNotes.length > 0 ? <NotesByRow notes={favoritesNotes}/> : <Alert variant="secondary">
                        У Вас пока нет избранных заметок
                    </Alert>}
        </>
    )
}